export const validator = {
  email_error_invalid: "Not a valid email address",

  pw_error:
    "Use 16 characters or more -OR- 8 characters or more with a mix of uppercase, lowercase & digits",
};
